import { addDoc, getDocs, collection, doc, deleteDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { asyncToaster } from '../utils/utility-functions';
import { toasterNotifications } from '../constants';


const productsCollectionRef = collection(db, "products");

export const addProduct = ({name, code, description, image, user}) => {
    const addProduct = addDoc(collection(db, 'products'), {
        code,
        name,
        description,
        image,
        createdAt: new Date().toLocaleString(), 
        user: user.name + ' ' + user.surname,
    });
    asyncToaster(addProduct, toasterNotifications.addProduct);
    return addProduct;
}

export const deleteProduct = (id) => {
    const product = deleteDoc(doc(db, 'products', id));
    asyncToaster(product, toasterNotifications.deleteProduct);
    return product;
};

export const getProductsService = async () => {
    const data = await getDocs(productsCollectionRef);
    return data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
}

export const editProduct =  ({id, name, code, description, image, user}) => {
    const productRef = doc(db, 'products', id);
    const newProductFields = {
        name,
        code,
        description,
        image, 
        createdAt: new Date().toLocaleString(), 
        user: user.name + ' ' + user.surname,
    };
    const product = setDoc(productRef, newProductFields);
    asyncToaster(product, toasterNotifications.editProduct);
    return product;
};